import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import {basePath} from 'helper/basePath';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a href={basePath+'Admin'}>PhotoVision</a>
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Admin/Footer/Footer.jsx